<app-generic-overlay
    [overlayOrigin]="overlayOrigin"
    [headerTemplate]="headerTemplate"
    [mainActionable]="mainActionable"
    [actionButtonsRef]="actionButtonsRef"
    (isOverlayOpenChange)="onOverlayChange($event)"
>
    <ng-template #headerTemplate let-close="close">
        <div class="header">
            <button class="resetStyles close-btn" aria-label="Close panel" (click)="close()">
                <div [innerHTML]="closeIcon" class="icon"></div>
            </button>
        </div>
    </ng-template>

    <div class="container">
        <form [formGroup]="form" class="formSection">
            @for (filterItem of additionalFilterItems(); track filterItem.fieldName + '-' + additionalEditorsEpoch()) {
                @switch (filterItem.componentId) {
                    @case (EditorType.dateRange) {
                        <div class="filterSection">
                            <app-date-range-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [rangeDirection]="'backward'"
                                [allowSelectEmptyDate]="shouldAllowSelectEmptyDate(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-date-range-form-editor>
                        </div>
                    }
                    @case (EditorType.dropdownRanges) {
                        <div class="filterSection">
                            <app-dropdown-ranges-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [iconType]="getIconType(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-dropdown-ranges-form-editor>
                        </div>
                    }
                    @case (EditorType.includeArchived) {
                        <div class="filterSection">
                            <app-include-archived-form-editor
                                [labelText]="getLabel(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-include-archived-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingProjectStatus) {
                        <div class="filterSection">
                            <app-report-project-status-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-project-status-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingChangeOrderStatus) {
                        <div class="filterSection">
                            <app-report-change-order-status-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-change-order-status-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingMarket) {
                        <div class="filterSection">
                            <app-report-market-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-market-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingOpportunitySource) {
                        <div class="filterSection">
                            <app-report-opportunity-source-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-opportunity-source-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingDepartment) {
                        <div class="filterSection">
                            <app-report-department-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-department-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingCompany) {
                        <div class="filterSection">
                            <app-report-company-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-company-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingCompanyType) {
                        <div class="filterSection">
                            <app-report-company-type-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-company-type-form-editor>
                        </div>
                    }
                    @case (EditorType.state) {
                        <div class="filterSection">
                            <app-report-state-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-state-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingBuildingClass) {
                        <div class="filterSection">
                            <app-report-building-class-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-building-class-form-editor>
                        </div>
                    }
                    @case (EditorType.estimateType) {
                        <div class="filterSection">
                            <app-report-estimate-type-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-estimate-type-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingAccount) {
                        <div class="filterSection">
                            <app-report-account-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-account-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingUser) {
                        <div class="filterSection">
                            <app-report-user-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-user-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingOpportunityStatus) {
                        <div class="filterSection">
                            <app-report-opportunity-status-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-opportunity-status-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingOpportunityProductTypes) {
                        <div class="filterSection">
                            <app-report-opportunity-product-types-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-opportunity-product-types-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingOpportunityCompanyRole) {
                        <div class="filterSection">
                            <app-report-opportunity-company-role-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-opportunity-company-role-form-editor>
                        </div>
                    }
                    @case (EditorType.reportingCompetingBidder) {
                        <div class="filterSection">
                            <app-report-competing-bidder-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-competing-bidder-form-editor>
                        </div>
                    }
                    @case (EditorType.bidCategories) {
                        <div class="filterSection">
                            <app-report-bid-categories-form-editor
                                [labelText]="getLabel(filterItem)"
                                [placeholderText]="getPlaceholder(filterItem)"
                                [formControlName]="getControlName(filterItem)"
                            ></app-report-bid-categories-form-editor>
                        </div>
                    }
                }
            }
        </form>

        <ng-template #actionButtonsRef let-close="close">
            <div class="action-buttons">
                <button
                    (click)="onClearFilters(close)"
                    class="tertiary-btn clear-btn"
                    [disabled]="!canClearAllFilters()"
                >
                    Clear All
                </button>
                <button (click)="onApply(close)" class="tertiary-btn apply-btn">Apply</button>
            </div>
        </ng-template>
    </div>
</app-generic-overlay>

<div cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin">
    <ng-template #mainActionable let-openClose="openClose">
        <button (click)="openClose()" [ngClass]="{ opened: opened() }" class="additional-btn tertiary-btn">
            <span
                class="icon"
                [class.applied]="!opened() && hasAppliedFilters()"
                [innerHTML]="!opened() && hasAppliedFilters() ? appliedAdditionalFiltersIcon : additionalFiltersIcon"
            ></span>
            <span>Additional filters</span>
        </button>
    </ng-template>
</div>
